import React, { useMemo } from 'react'
import { Col, Layout, Row, Image, Divider, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faLinkedinIn, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { useIntegrationContext } from '../../../context/integration'
import CustomLink from '../CustomLink/CustomLink'

import logo from '../../../images/icons/logo.png'

import { currentBrand } from '../../../config'
import './footer.css'
import { useBrandContext } from '../../../context/brand'
import { IntegrationTypes } from '../../../context/types'

const { Footer: AntFooter } = Layout
const { Link: AntLink } = Typography

interface CustomWindow extends Window {
	Tawk_API?: any
}

const handleContactUs = () => {
	const w = window as CustomWindow
	if (w.Tawk_API && w.Tawk_API.getStatus && w.Tawk_API.getStatus() !== 'offline') {
		w.Tawk_API.toggle()
	} else {
		window.location.href = `mailto:${currentBrand.contactEmail}`
	}
}

const cbHandlers: { [cbName: string]: () => void } = {
	handleContactUs,
}

function Footer() {
	const { integration } = useIntegrationContext()
	const { brand } = useBrandContext()

	if (integration.config?.footer === false) {
		return null
	}

	const landingUrl = useMemo(
		() => (integration.type === IntegrationTypes.embed ? '/' : currentBrand.landingUrl || '/'),
		[integration.type]
	)

	return (
		<>
			{integration.isInviteExpert && integration.content?.register_expert_footer && (
				<AntFooter className="footer" style={{ marginBottom: -20 }}>
					<div dangerouslySetInnerHTML={{ __html: integration.content?.register_expert_footer }} />
				</AntFooter>
			)}

			<AntFooter className="footer">
				<Row align="middle" className="footer-content" gutter={[16, 0]} wrap={false}>
					<Col flex="140px">
						<CustomLink to={landingUrl} target="_blank">
							<Image src={currentBrand.logoUrl || logo} preview={false} referrerPolicy="no-referrer" />
						</CustomLink>
						<Divider />
						<Space size="middle">
							{brand.currentBrand?.settings?.social_media.facebook && (
								<AntLink href={brand.currentBrand?.settings?.social_media.facebook} target="_blank">
									<FontAwesomeIcon icon={faFacebookF} color={currentBrand.styles['@primary-color']} size="lg" />
								</AntLink>
							)}
							{brand.currentBrand?.settings?.social_media.linkedin && (
								<AntLink href={brand.currentBrand?.settings?.social_media.linkedin} target="_blank">
									<FontAwesomeIcon icon={faLinkedinIn} color={currentBrand.styles['@primary-color']} size="lg" />
								</AntLink>
							)}
							{brand.currentBrand?.settings?.social_media.instagram && (
								<AntLink href={brand.currentBrand?.settings?.social_media.instagram} target="_blank">
									<FontAwesomeIcon icon={faInstagram} color={currentBrand.styles['@primary-color']} size="lg" />
								</AntLink>
							)}
							{brand.currentBrand?.settings?.social_media.twitter && (
								<AntLink href={brand.currentBrand?.settings?.social_media.twitter} target="_blank">
									<FontAwesomeIcon icon={faTwitter} color={currentBrand.styles['@primary-color']} size="lg" />
								</AntLink>
							)}
						</Space>
					</Col>
					<Col flex="auto">
						<Row justify="space-between" wrap gutter={[8, 8]}>
							<Col xs={0} sm={0} md={0} lg={1} xl={1} />
							{Object.keys(currentBrand.footerLinks).map((column) => (
								<Col flex="none" key={column}>
									<Space direction="vertical">
										{currentBrand.footerLinks[column].map(({ name, to, target, cbName }) => (
											<CustomLink key={name} to={to} target={target} onClick={cbName && cbHandlers[cbName]}>
												{name}
											</CustomLink>
										))}
									</Space>
								</Col>
							))}
							<Col flex="none">
								{/* <Space direction="vertical">
								<Row justify="space-between" gutter={[8, 0]}>
									<Col flex="none">
										<FontAwesomeIcon icon={faMapMarkerAlt} color="#96C6E4" size="1x" />
									</Col>
									<Col flex="1">860 Worcester Road Framingham, MA, United States, 01702</Col>
								</Row>
								<Row justify="space-between" gutter={[8, 0]}>
									<Col flex="none">
										<FontAwesomeIcon icon={faPhoneAlt} color="#96C6E4" size="1x" />
									</Col>
									<Col flex="1">5088348121</Col>
								</Row>
							</Space> */}
							</Col>
						</Row>
					</Col>
				</Row>
			</AntFooter>
		</>
	)
}

export default Footer
